export class FileDto {
  name: string
  key: string
  url: string
  /** Blob path, which is what a settings document stores. */
  path: string
}

export class UploadFileDto {
  filename: string
  fileKey: string
  content: string
}

export class BrandFileKeys {
  //unique key
  static Favicon = 'Favicon'
  static Logo = 'Logo'
  static LogoWhite = 'LogoWhite'
  static CardArt = 'CardArt'
  static HomeBackground = 'HomeBackground'
  static LoginWatermark = 'LoginWatermark'

  //multiple keys
  static MarketingBanner = 'MarketingBanner'
}

export const UniqueFileKeys = [
  BrandFileKeys.Favicon,
  BrandFileKeys.Logo,
  BrandFileKeys.LogoWhite,
  BrandFileKeys.CardArt,
  BrandFileKeys.HomeBackground,
  BrandFileKeys.LoginWatermark
]